import { render, staticRenderFns } from "./NoActivityDialog.vue?vue&type=template&id=6ff2751a&scoped=true"
import script from "./NoActivityDialog.vue?vue&type=script&lang=js"
export * from "./NoActivityDialog.vue?vue&type=script&lang=js"
import style0 from "./NoActivityDialog.vue?vue&type=style&index=0&id=6ff2751a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff2751a",
  null
  
)

export default component.exports